__turbopack_context__.v({
  "privacyPolicyContainer": "privacy-policy-module-scss-module__09ENLG__privacyPolicyContainer",
});
